/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of TransactionTypesClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  SuccessResponse_1OfIEnumerable_1OfGetTransactionTypeResponse,
  PatchTransactionTypeRequest,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockTransactionTypes = [
  { id: 1, name: 'Sale', displayName: 'Point of Sale', enabled: true, direction: 'Out', type: 'Sale' },
  { id: 2, name: 'Receipt', displayName: 'Goods Received', enabled: true, direction: 'In', type: 'Receipt' },
  { id: 3, name: 'Waste', displayName: 'Waste/Spoilage', enabled: true, direction: 'Out', type: 'Waste' },
  { id: 4, name: 'Adjustment', displayName: 'Stock Adjustment', enabled: true, direction: 'Both', type: 'Adjustment' },
  { id: 5, name: 'Transfer', displayName: 'Inter-store Transfer', enabled: true, direction: 'Both', type: 'Transfer' },
];

/* ---- Mocked Client Implementation ---- */

import { ITransactionTypesClient } from '../../interfaces';
export class TransactionTypesClientMocked implements ITransactionTypesClient {
  constructor(baseUrl?: string) {}

  async typesGET(storeNumber: string, enabled?: boolean, cancelToken?: CancelToken): Promise<SuccessResponse_1OfIEnumerable_1OfGetTransactionTypeResponse> {
    await delay();
    let types = [...mockTransactionTypes];
    if (enabled !== undefined) {
      types = types.filter((t) => t.enabled === enabled);
    }
    return successResponse(types) as SuccessResponse_1OfIEnumerable_1OfGetTransactionTypeResponse;
  }

  async typesPATCH(id: number, body?: PatchTransactionTypeRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const type = mockTransactionTypes.find((t) => t.id === id);
    if (type && body) {
      type.enabled = body.enabled ?? type.enabled;
    }
  }

  // ====== Auto-generated stub methods ======



}
